import React, { FC } from "react";
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";

interface SortOption {
  label: string;
  segment: string;
  action: () => void;
}

interface SortingDropdownProps {
  sortings: SortOption[];
  selected?: SortOption;
  onSelectionChange: (selection: SortOption) => void;
}

const SortingDropdown: FC<SortingDropdownProps> = ({
  sortings,
  selected,
  onSelectionChange,
}) => {
  return (
    <Listbox value={selected} onChange={onSelectionChange}>
      {({ open }) => (
        <>
          <div className="flex items-center h-10 p-2 mb-2 rounded cursor-pointer bg-transparent backdrop-blur-2xl border border-[#ffffff80] whitespace-nowrap overflow-hidden outline-none focus:outline-none">
            <ListboxButton className="flex items-center outline-none focus:outline-none">
              <span className="flex-grow text-left truncate outline-none focus:outline-none">
                {selected?.label || "Kies sortering"}
              </span>
              <span
                className={`d-icon d-arrowhead-down flex items-center text-white ml-2 flex-shrink-0 ${open ? "-scale-y-100" : ""}`}
              ></span>
            </ListboxButton>
          </div>
          <ListboxOptions className="absolute rounded border-2 border-[#ffffff80] text-white top-full mt-1 py-2 w-full left-0 backdrop--tinted outline-none focus:outline-none">
            {sortings.map((sorting) => (
              <ListboxOption
                key={sorting.label}
                value={sorting}
                className={({ focus }) =>
                  `px-2 py-1 hover:bg-opacity-20 hover:bg-white cursor-pointer ${
                    focus ? "" : ""
                  }`
                }
              >
                {sorting.label}
              </ListboxOption>
            ))}
          </ListboxOptions>
        </>
      )}
    </Listbox>
  );
};

export default SortingDropdown;
